<template>
  <div class="pdf-wrapper">
    <object data="/static/docs/pp-2021-10-01.pdf" type="application/pdf" width="100%" height="100%">
      <p>It appears you don't have a PDF plugin for this browser.</p>
    </object>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.pdf-wrapper {
  width: 100vw;
  height: 100vh;
}
</style>
